angular.module('impactx.user')
    .directive('ixReferenceUserList', function($window) {
        return {
            scope: {
                data: "=",
                useContactDialog: "="
            },
            restrict: 'E',
            templateUrl: "shared/user/templates/referenceuserlist.tmpl.html",
            transclude: true
        };
    });